import api from "../api";

const AIDocumentService = {
  async list() { return (await api.get("/ai-documents")).data; },
  async generate(payload) { return (await api.post("/ai-documents/generate", payload)).data; },
  async create(payload) { return (await api.post("/ai-documents", payload)).data; },
  async update(id, payload) { return (await api.put("/ai-documents/" + id, payload)).data; },
  async remove(id) { return api.delete("/ai-documents/" + id); },
  async pin(id) { return (await api.put("/ai-documents/" + id + "/pin")).data; },
  async unpin(id) { return (await api.delete("/ai-documents/" + id + "/pin")).data; },
  async preset() { return (await api.get("/ai-documents/preset")).data; },
  async savePreset(payload) { return (await api.put("/ai-documents/preset", payload)).data; },
  async accessOptions() { return (await api.get("/ai-documents/access-options")).data; },
  async prepareFolder(id) { return (await api.put("/ai-documents/" + id + "/folder")).data; },
  async uploadPdf({ blob, id, title, category }) {
    const data = new FormData();
    const safeTitle = title || "documento";
    data.append("file", new File([blob], safeTitle + ".pdf", { type: "application/pdf" }));
    data.append("categoryName", "Documentos IA");
    data.append("categorySlug", "documentos-ia");
    data.append("formName", category || "Geral");
    data.append("fieldName", safeTitle);
    data.append("fieldSlug", "doc-" + id);
    data.append("generatedFileName", safeTitle + ".pdf");
    return (await api.post("/upload", data, { headers: { "Content-Type": "multipart/form-data" } })).data;
  },
  async updateFolderAccess(folderId, userIds, sectorIds) {
    return (await api.put("/document-folders/" + folderId + "/access", { userIds, sectorIds })).data;
  },
};

export default AIDocumentService;
